import { useTimer } from "@/hooks/useCountdown";
import { dataProps } from "@/models/data.model";
import { FC, JSX } from "react";

import CountdownUI from "../../../challengeUpcoming/CountdownUI/CountdownUI";

const LeaderboardEmpty: FC<dataProps> = (data): JSX.Element => {
  const { timeObj } = useTimer(data.challenge?.data?.endDate || undefined);

  return <CountdownUI title="CHALLENGE ENDS IN" timeObj={timeObj} {...data} />;
};

export default LeaderboardEmpty;
